import { initComponent } from './core/init-component.js'

initComponent('.js-ls-input', snippet => {
  const input = snippet.querySelector('input[type="text"]')
  if (!input) return {}

  const maxlength = input.getAttribute('maxlength')
  if (!maxlength) return {}

  const lengthDisplay = snippet.querySelector('.js-ls-input-length')
  if (!lengthDisplay) return {}

  const maxCounterText = `(${maxlength}/${maxlength})`

  const ruler = document.createElement('span')
  ruler.style.position = 'absolute'
  ruler.style.visibility = 'hidden'
  ruler.style.height = 'auto'
  ruler.style.width = 'auto'
  ruler.style.whiteSpace = 'nowrap'
  ruler.style.font = window.getComputedStyle(lengthDisplay).font
  ruler.textContent = maxCounterText
  document.body.appendChild(ruler)

  const paddingRightValue = ruler.offsetWidth + 18

  input.style.paddingRight = `${paddingRightValue}px`

  document.body.removeChild(ruler)

  function updateLength() {
    lengthDisplay.textContent = `(${input.value.length}/${maxlength})`
  }

  updateLength()
  input.addEventListener('input', updateLength)

  return {
    unload() {
      input.removeEventListener('input', updateLength)
      input.style.paddingRight = ''
    }
  }
})
